import { ErrorPage } from "@/components/error-page/error-page";
import { useTranslation } from "react-i18next";
import { useSearch } from "wouter";

export function ForbiddenView() {
  const { t } = useTranslation("common");
  const search = useSearch();
  const retryPath = getRetryPath(search);

  return (
    <ErrorPage
      errorCode={403}
      title={t("ForbiddenViewTitle")}
      message={t("ForbiddenViewMessage")}
      description={t("ForbiddenViewDescription")}
      reloadTo={retryPath}
    />
  );
}

function getRetryPath(search: string) {
  const retryPath = new URLSearchParams(search).get("retry");

  if (!retryPath || !retryPath.startsWith("/") || retryPath.startsWith("//") || retryPath.startsWith("/forbidden")) {
    return undefined;
  }

  return retryPath;
}
